module.exports = __webpack_public_path__ + "static/media/logo-la-redoute.96163c33.png";